const StepId = {
    PATIENT_INFO: "patientInfo",
    JOINT_APPLICANT_INFO: "jointApplicantInfo",
    TERMS: "termsAndConditions",
    ACCEPT_OFFER: "acceptOffer",
    PAYMENT_OPTIONS: "paymentOptions",
    COMPLETE: "complete",
    BEGIN_STANDARD_APPLICATION: "beginStandardApplication"
}

export default StepId
